import { render, staticRenderFns } from "./CoursePriceField.vue?vue&type=template&id=46e848b4&scoped=true"
import script from "./CoursePriceField.vue?vue&type=script&lang=ts"
export * from "./CoursePriceField.vue?vue&type=script&lang=ts"
import style0 from "./CoursePriceField.vue?vue&type=style&index=0&id=46e848b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e848b4",
  null
  
)

export default component.exports